import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/user-roles/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const userRoles = {
  getAll: apiPathFunc(pathBase),
} as const;
